
import { booleanProp } from '@/mixins'
import { defineComponent, computed } from 'vue'

export default defineComponent({
  name: 'FrCard',
  props: {
    alert: booleanProp(false),
    square: booleanProp(false),
    bordered: booleanProp(false),
    flat: booleanProp(false),
    width: {
      type: String,
      default: () => 'auto'
    }
  },
  setup(props, { slots }) {
    const classes = computed(() => {
      return [
        props.bordered ? 'bodered border-gray-300' : '',
        !props.flat ? 'shadow-md' : '',
        props.square ? '' : 'rounded'
      ]
    })
    const hasSlotPopulated = (slotsName: string): boolean => {
      return !!slots[slotsName]
    }
    return { classes, hasSlotPopulated }
  }
})
